import { Component, EventEmitter, Output } from "@angular/core";

@Component({
    selector: "cerrix-accordion",
    imports: [],
    template: ""
})
export class CerrixAccordionComponent {
    @Output() public emitToggle = new EventEmitter<boolean>();
    public isOpen: boolean = false;

    public expandAccordion(): void {
        this.isOpen = true;
    }

    public collapseAccordion(): void {
        this.isOpen = false;
    }

    public toggleAccordion(): void {
        this.isOpen = !this.isOpen;
        this.emitToggle.emit(this.isOpen);
    }
}
